import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61295b56"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-d-flex p-flex-column p-align-center p-p-6"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Enter your e-mail address, you will receive a one-time code to reset your password.", -1))
const _hoisted_3 = { class: "p-mt-2 error-p" }
const _hoisted_4 = {
  key: 0,
  class: "p-mt-2 error-p"
}
const _hoisted_5 = {
  key: 1,
  class: "p-d-flex p-flex-column p-align-center p-p-6"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Restore code", -1))
const _hoisted_7 = {
  key: 0,
  class: "error-p"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-mt-2 error-p" }, "This is the six-digit verification code that was sent to your email address.", -1))
const _hoisted_9 = { class: "p-d-flex p-ai-center w-50 p-justify-between" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "p-m-0" }, "New password: ", -1))
const _hoisted_11 = { class: "p-d-flex p-ai-center w-50 p-justify-between" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "p-m-0" }, "Confirm new password:", -1))
const _hoisted_13 = { class: "p-mt-2 error-p" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: "Restore password",
    closable: false,
    style: { width: '1000px', minHeight: 'auto' } ,
    visible: _ctx.show,
    modal: true
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Close",
        class: "p-button-text",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
      })
    ]),
    default: _withCtx(() => [
      (_ctx.steepRestore === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_InputText, {
              type: "text",
              placeholder: "You E-mail",
              modelValue: _ctx.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
            }, null, 8, ["modelValue"]),
            _withDirectives(_createElementVNode("p", _hoisted_3, "This field must be a valid email address.", 512), [
              [_vShow, _ctx.emailInvalid]
            ]),
            (!_ctx.emailInvalid && _ctx.invalidEmail)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "No user found with this email"))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createVNode(_component_Button, {
                disabled: _ctx.emailInvalid,
                class: "red-button p-mt-5 w-100 btn",
                onClick: _ctx.sendCode
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Send the code")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.steepRestore === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_InputNumber, {
              modelValue: _ctx.restoreCode,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.restoreCode) = $event)),
              min: 0,
              mode: "decimal",
              useGrouping: false
            }, null, 8, ["modelValue"]),
            (_ctx.vereficationCodeBad)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.vereficationCodeBad), 1))
              : _createCommentVNode("", true),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_Password, {
                class: "p-ml-2",
                modelValue: _ctx.newPassword,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPassword) = $event)),
                toggleMask: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_Password, {
                class: "p-ml-2 p-mt-2",
                modelValue: _ctx.newPasswordConfirm,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newPasswordConfirm) = $event)),
                toggleMask: ""
              }, null, 8, ["modelValue"])
            ]),
            _withDirectives(_createElementVNode("p", _hoisted_13, " Password must be at least 8 characters long and new passwords must match. ", 512), [
              [_vShow, !_ctx.validNewPasswords]
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_Button, {
                class: "red-button p-mt-5 w-100 btn",
                onClick: _ctx.checkAndChangePassword
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Change password")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible"]))
}